import { useQuery } from 'react-query';
import type { AxiosError } from 'axios';

import { axiosInstance } from '@shared/lib/axios';
import type { TUser } from '@entities/user/lib/types';
import { QUERIES_INFO } from '@shared/lib/const';

export const useGetUser = (uuid: string, onError?: (error: AxiosError) => void) =>
  useQuery(
    [QUERIES_INFO.user.key, uuid],
    () =>
      axiosInstance
        .get<TUser>(QUERIES_INFO.user.endpoint.replace('[uuid]', uuid))
        .then((response) => response.data)
        .catch((e) => {
          onError?.(e);
        }),
    { enabled: !!uuid },
  );
